import { http } from "../../utils";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks";

function fetchLotData(params, id) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(`/admin/product-lots?productId=${id}`, baseUrl);

  if (params.type) {
    endpointUrl.searchParams.append("type", params.type);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    pageSize: 5,
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useLotData(params = {}, id) {
  return usePaginationQuery(
    ["product-lots", params.keyword, params.type],
    (paginationState) => fetchLotData({ ...params, ...paginationState }, id)
  );
}
// {{local}}/product-lots?page=1&pageSize=100&productId=xxx

function fetchLotDataById(params, id) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(`/admin/product-lots?productId=${id}`, baseUrl);

  if (params.type) {
    endpointUrl.searchParams.append("type", params.type);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    pageSize: 5,
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useLotDataById(params = {}, id) {
  return usePaginationQuery(
    ["product-lots", params.keyword, params.type],
    (paginationState) => fetchLotDataById({ ...params, ...paginationState }, id)
  );
}
